import React, { Component } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { sisaQuotaTrayekPerBulan } from '../../actions/dashboardAction'
import { FORM_VESSEL_OP } from '../../actions/constant'
import { Card, CardBody, CardHeader, CardFooter, Row, Col, Table, Pagination, PaginationItem, PaginationLink } from 'reactstrap'

let userId = localStorage.getItem('tolaut@userId') || null
let form = localStorage.getItem('tolaut@form') || null

class DashboardSisaQuotaTrayek extends Component {
  constructor(props) {
    super(props)
    this.state = {
      curPage: 1,
    }
  }
  componentDidMount() {
    let data = {
      length: 10
    }

    if (form === FORM_VESSEL_OP) {
      data.operator_id = userId
    }

    this.props.sisaQuotaTrayekPerBulan(data)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.curPage !== this.state.curPage) {
      let offset = (this.state.curPage * 10) - 10
      let data = {
        length: 10 ,
        start: offset
      }
      this.props.sisaQuotaTrayekPerBulan(data)
    }
  }


  changeRupiah(bilangan) {
    var number_string = bilangan.toString(),
      sisa = number_string.length % 3,
      rupiah = number_string.substr(0, sisa),
      ribuan = number_string.substr(sisa).match(/\d{3}/g);
    if (ribuan) {
      let separator = sisa ? '.' : '';
      rupiah += separator + ribuan.join('.');
    }
    return rupiah
  }
  handleClick(e) {
    this.setState({ curPage: e, start:this.state.start + 10 })
  }

  renderData(){
    if (this.props.sisaQuotaTrayekIsSuccess) {
      const prevPage = parseInt(this.props.sisaQuotaTrayekData.currentPage) - 1
      const nextPage = parseInt(this.props.sisaQuotaTrayekData.currentPage) + 1

      let curPage = this.props.sisaQuotaTrayekData.currentPage
      let minPage = Number(curPage) - 2
      let maxPage = Number(curPage) + 2
      const pages = []
      const totalPages = this.props.sisaQuotaTrayekData.pageTotal

      for (let index = 1; index <= totalPages; index++) {
        if (pages.indexOf(index) == -1) {
          pages.push(index)
        }
      }

      return (
        <Row>
          <Col xs="12" lg="12" md="12" lg="12">
            <Card>
              <CardHeader className="text-center">
                <h5>Daftar Sisa Kuota Trayek {moment().format('MMMM YYYY')}</h5>
              </CardHeader>
              <CardBody className="p-0">
                {this.props.sisaQuotaTrayekIsSuccess &&
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>Trayek</th>
                        <th>Kuota</th>
                        <th>Sisa Kuota</th>
                        <th>Tipe Kontainer</th>
                        <th>ETD Trayek</th>
                        <th>ETA Trayek</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.sisaQuotaTrayekData.data.map((item, key) => (
                        <tr key={key}>
                          <td>{item.kode_trayek}</td>
                          <td>{item.total_alokasi_quota}</td>
                          <td>{item.total_sisa}</td>
                          <td>{item.type_container_name}</td>
                          <td>{moment(item.etd).format('DD MMMM YYYY')}</td>
                          <td>{moment(item.eta).format('DD MMMM YYYY')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                }
              </CardBody>
              <CardFooter>
                <Pagination>
                  {this.props.sisaQuotaTrayekData.hasPrev ?
                    <PaginationItem>
                      <PaginationLink previous tag="button" onClick={(e) => this.handleClick(1)}>
                        First Page
                  </PaginationLink>
                    </PaginationItem>
                    : null
                  }

                  {this.props.sisaQuotaTrayekData.hasPrev ?
                    <PaginationItem>
                      <PaginationLink previous tag="button" onClick={(e) => this.handleClick(prevPage)}>
                        Prev
                  </PaginationLink>
                    </PaginationItem>
                    : null
                  }

                  {pages.map((item, index) => {
                    let actived = false
                    if (curPage === undefined) {
                      curPage = 1
                    }

                    if (item == curPage) {
                      actived = true
                    }

                    if (item >= minPage && item <= maxPage) {
                      return <PaginationItem active={actived} key={index}>
                        <PaginationLink tag="button" onClick={(e) => this.handleClick(item)}>
                          {item}
                        </PaginationLink>
                      </PaginationItem>
                    }
                  })}

                  {this.props.sisaQuotaTrayekData.hasNext ?
                    <PaginationItem>
                      <PaginationLink next tag="button" onClick={(e) => this.handleClick(nextPage)}>
                        Next
                  </PaginationLink>
                    </PaginationItem>
                    : null
                  }

                  {this.props.sisaQuotaTrayekData.hasNext ?
                    <PaginationItem>
                      <PaginationLink next tag="button" onClick={(e) => this.handleClick(totalPages)}>
                        Last Page
                  </PaginationLink>
                    </PaginationItem>
                    : null
                  }
                </Pagination>

                {this.props.sisaQuotaTrayekData.pageTotal > 0 &&
                  <p>Page: {this.props.sisaQuotaTrayekData.currentPage} of {this.props.sisaQuotaTrayekData.pageTotal}</p>
                }
              </CardFooter>
            </Card>
          </Col>
        </Row>
      )
    }else{
      return "Loading ..."
    }
  }


  render() {
    if (this.props.sisaQuotaTrayekIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.sisaQuotaTrayekHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        {this.renderData()}
      </div>
    )
  }
}

DashboardSisaQuotaTrayek.propTypes = {
  sisaQuotaTrayekIsSuccess: PropTypes.bool.isRequired,
  sisaQuotaTrayekHasError: PropTypes.bool.isRequired,
  sisaQuotaTrayekIsLoading: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    sisaQuotaTrayekData: state.dashboard.sisaQuotaTrayekPerBulanData,
    sisaQuotaTrayekIsSuccess: state.dashboard.sisaQuotaTrayekPerBulanSuccess,
    sisaQuotaTrayekHasError: state.dashboard.sisaQuotaTrayekPerBulanError,
    sisaQuotaTrayekIsLoading: state.dashboard.sisaQuotaTrayekPerBulanLoading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    sisaQuotaTrayekPerBulan: (data) => dispatch(sisaQuotaTrayekPerBulan(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardSisaQuotaTrayek)